export default __webpack_public_path__ + "static/offcuts-3a4133fa04dd8c187b072c72439e78db.png";